import "@/directive";
import 'lib-flexible/flexible.js'
import appMixin from "@/mixins/app.mixin";
import debounce from "@/mixins/debounce.mixin";

import "@/assets/js/calc.js";
import 'vue-country-intl/lib/vue-country-intl.css'
import "@/assets/theme/index.css";
import "@/assets/theme/meta.less";
import socketApi from '@/assets/socket/socketApi.js';
import filterFunParams from '@/assets/js/newApiPramas.js';
import numberInput from "@/assets/js/custom-instruction.js";
import { SERVEURL } from '@/assets/js/assetSeverUrl.js'
import Util from '@/common/commonUtils';
import Subscription from '@/assets/socket/subscription.js';

import decimalToFixed from "@/plugins/decimalobj.js";
import { index, tradingContest } from "@/assets/js/api.url.js";
import { Http } from "@/common/ts/index";

//以下vant代码是为了增加合约的H5响应式弹窗
import "vant/lib/notify/style";
import "vant/lib/toast/style";
import { Notify, Toast } from "vant";

//国际化
import i18n from "./i18n/index.js";

import router from "./router";

//vuex
import store from "./store";

window.Notify = Notify;
window.Toast = Toast;

import "./assets/js/vue.extends";

// 非生产：阿里云验证码等会调用 console.clear；vConsole 初始化后会再次覆盖 console，需在 new VConsole 之后重复打补丁
// function installBkgConsoleClearNoop() {
// 	if (typeof window === "undefined" || typeof console === "undefined") return;
// 	if (!window.__bkgOrigConsoleClear && typeof console.clear === "function") {
// 		window.__bkgOrigConsoleClear = console.clear.bind(console);
// 	}
// 	window.__bkgConsoleClearNoop = true;
// 	const noop = function bkgDevNoOpConsoleClear() {
// 		/* 需原生清空：console.clear = window.__bkgOrigConsoleClear; console.clear(); */
// 	};
// 	try {
// 		Object.defineProperty(console, "clear", {
// 			configurable: true,
// 			enumerable: true,
// 			writable: true,
// 			value: noop,
// 		});
// 	} catch (e) {
// 		console.clear = noop;
// 	}
// }
// if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "expect") {
// 	installBkgConsoleClearNoop();
// 	const VConsole = require("vconsole");
// 	new VConsole({
// 		maxLogNumber: 10000,
// 	});
// 	installBkgConsoleClearNoop();
// 	queueMicrotask(() => installBkgConsoleClearNoop());
// 	[50, 300].forEach((ms) => setTimeout(() => installBkgConsoleClearNoop(), ms));
// }
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$SERVEURL = SERVEURL;
Vue.prototype.$swapsApi = socketApi;
Vue.prototype.$filterFunParams = filterFunParams;
 //注册
 Vue.prototype.$register = function (ob) {
  Subscription.getInstance().add(ob);
};
//取消注册
Vue.prototype.$unRegister = function (ob) {
  Subscription.getInstance().remove(ob);
};
//发通知
Vue.prototype.$notify = function (tag, data) {
  Subscription.getInstance().notify(tag, data);
};
  //工具函数
Vue.prototype.$util = Util;
Vue.prototype.$timerFormat = function (v, fmt) {
  if (!v) return "";
  let time = new Date(v);
  let o = {
    "M+": time.getMonth() + 1, //月份
    "d+": time.getDate(), //日
    "h+": time.getHours(), //小时
    "m+": time.getMinutes(), //分
    "s+": time.getSeconds(), //秒
    "q+": Math.floor((time.getMonth() + 3) / 3), //季度
    S: time.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (time.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
Vue.prototype.$desensitize = function (value) {
  if (!value) return ''

  // 邮箱脱敏
  if (value.includes('@')) {
    const [username, domain] = value.split('@')
    // if (username.length <= 2) {
    //   return '*'.repeat(username.length) + '@' + domain
    // }
    return username.substring(0, 3) + '****@' + domain
  }

  // 手机号脱敏
  if (/^1[3-9]\d{9}$/.test(value)) {
    return value.substring(0, 3) + '****' + value.substring(7)
  }

  // 其他类型的脱敏可以继续添加
  return value
}
Vue.prototype.$globalSwitchDisplay = function(value) {
  if (!store.getters.getSwitchDisplay) {
    return '******'
  }
  return value
}
Vue.prototype.$percentageTofixed = function(value) {
  if (Number(value) == 0) return 0
  if (value) {
    return Math.fround((Number(value) * 100)).toFixed(2)
  }
}

Vue.prototype.$location = function() {
  switch(i18n.locale) {
    case 'pt_BR':
      return 'pt';
    case 'id_ID':
      return 'ind';
    default:
      // return i18n.locale.replace('_', '-').toLowerCase();
      return i18n.locale.toLowerCase();
  }
}
// 保留小数点后的有效数字
Vue.prototype.$trimZeros = function(num) {
  // 将数字转换为字符串，并以点分隔
  const numStr = num && num.toString();
  const parts = numStr && numStr.split('.');

  // 如果小数点后只有零，则直接返回整数部分
  if (parts && parts.length === 1) {
    return numStr;
  }

  // 使用正则表达式去除小数点后的多余零
  const trimmedPart = parts && parts[1].replace(/0+$/, '');
  // 如果去除后没有任何数字，则返回整数部分
  if (!trimmedPart) {
    return parts[0] || 0;
  }

  // 返回结果
  return parts[0] + '.' + trimmedPart;
}

// 保留充提地址
Vue.prototype.$truncateAddress = function(str) {
  // 判断字符串长度
  if (str.length <= 12) {
    return str; // 如果长度小于等于 12，直接返回原字符串
  }
  // 保留前6位和后6位，中间以省略号替代
  const start = str.slice(0, 6);
  const end = str.slice(-6);
  return `${start}...${end}`;
},

// 输入整数或小数
Vue.directive("number-input", numberInput);

Vue.filter("numscale", function (value) {
  if (typeof +value === "number" && !isNaN(value)) {
    if (value < 1000) {
      return value;
    } else if (value >= 1000 && value < 10000) {
      return (
        Vue.prototype.$decimalToFixed(value / 1000, 3) + i18n.t("common.qian")
      );
    } else if (value >= 10000 && value < 1000000000) {
      return (
        Vue.prototype.$decimalToFixed(value / 10000, 3) + i18n.t("common.wan")
      );
    } else {
      return (
        Vue.prototype.$decimalToFixed(value / 1000000000, 3) +
        i18n.t("common.yi")
      );
    }
  } else {
    return "--";
  }
});
function handleGetFloat(num, n) {
  num = +num;
  n = n ? parseInt(n) : 0;
  if (n <= 0) {
    return Math.round(num);
  }
  num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
  num = Number(num).toFixed(n); //补足位数
  return num;
}
Vue.filter("newNumScale", function (value) {
  if (typeof +value === "number" && !isNaN(value)) {
    if (value < 1000) {
      return handleGetFloat(value, 3);
    } else if (value >= 1000 && value < 1000000) {
      return handleGetFloat(value / 1000, 3) + "K";
    } else if (value >= 1000000 && value < 1000000000) {
      return handleGetFloat(value / 1000000, 3) + "M";
    } else {
      return handleGetFloat(value / 1000000000, 3) + "B";
    }
  } else {
    return "0";
  }
});
Vue.filter("handleShowStr", function (inputNumber) {
  if (isNaN(inputNumber)) {
    return inputNumber;
  }
  inputNumber = "" + inputNumber;
  inputNumber = parseFloat(inputNumber);
  let eformat = inputNumber.toExponential(); // 转换为标准的科学计数法形式（字符串）
  let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值
  let number = inputNumber.toFixed(
    Math.max(0, (tmpArray[1] || "").length - tmpArray[2])
  );
  return number;
});
//小数点超过8位不准，全局设置一个处理精度函数插件
Vue.use(decimalToFixed);

// 引入mockjs
// require("./mock");

//web安全
import { isIframe, isSqlSafe } from "@/common/ts/share";

// Svg 暂时全局引入
// import "@/icons"; // svg icon

Vue.config.productionTip = false;

//web环境安全检测
// if (!isIframe() && isSqlSafe(window.location.href)) {
let rootNode = document.createElement("div");
const App = () => import("./App");

rootNode.id = "biking-application";
document.body.appendChild(rootNode);

Vue.mixin(appMixin);
Vue.mixin(debounce);
const {pathname, search} = location

if (window.isMobile) {
  let body = document.getElementsByTagName("body")[0];
  body.classList.add("mobile");
}
// 注册路由渲染哪个页面需要根据接口来判断；
if (pathname.includes('/futures/register') || pathname.includes('/registers')) {
  const $http = new Http();
  const paramObj = {}
  if (search) {
    const paramArr = search.replace('?', '').split('&')
    paramArr.forEach(item => {
      const [key, value] = item.split('=')
      paramObj[key] = value
    })
    $http.get({
      url: index.registerSwitch,
      data: {invitationCode: paramObj.agentid ? paramObj.agentid : '123456'}
    }).then(res => {
      if (res.code == 200) {
        const {pcStatus, h5Status} = res.data
        sessionStorage.setItem('register_switch', JSON.stringify({pcStatus, h5Status}))
        window.vm = new Vue({
          store,
          router,
          i18n,
          components: { App },
          render: (h) => h(App),
          mounted() {
            document.dispatchEvent(new Event("render-event"));
          },
        }).$mount("#biking-application");
      }
    }).catch(error => {
      sessionStorage.setItem('register_switch', JSON.stringify({pcStatus: '0', h5Status: '0'}))
      window.vm = new Vue({
        store,
        router,
        i18n,
        components: { App },
        render: (h) => h(App),
        mounted() {
          document.dispatchEvent(new Event("render-event"));
        },
      }).$mount("#biking-application");
    })
  } else {
    // 没有代理号，不走开关接口;
    sessionStorage.setItem('register_switch', JSON.stringify({pcStatus: '0', h5Status: '0'}))
    window.vm = new Vue({
      store,
      router,
      i18n,
      components: { App },
      render: (h) => h(App),
      mounted() {
        document.dispatchEvent(new Event("render-event"));
      },
    }).$mount("#biking-application");
  }
}
else if (pathname.includes('/futures/trading-contest') || pathname.includes('/trading-contest') || pathname.includes('/h5/index') || pathname.includes('/h5/trading')) {
  const $http = new Http();
  $http.get({
    url: tradingContest.getActivityDetail,
    data: {}
  }).then(res => {
    const {startTime, endTime, blindBoxRatio, superPrizePoolRatio} = res.data
    sessionStorage.setItem('activity_time', JSON.stringify({startTime, endTime, blindBoxRatio , superPrizePoolRatio}))
    window.vm = new Vue({
      store,
      router,
      i18n,
      components: { App },
      render: (h) => h(App),
      mounted() {
        document.dispatchEvent(new Event("render-event"));
      },
    }).$mount("#biking-application");
  }).catch(error => {
    sessionStorage.setItem('activity_time', JSON.stringify({startTime: 0, endTime: 0, blindBoxRatio: '80', superPrizePoolRatio: '20' }))
    window.vm = new Vue({
      store,
      router,
      i18n,
      components: { App },
      render: (h) => h(App),
      mounted() {
        document.dispatchEvent(new Event("render-event"));
      },
    }).$mount("#biking-application");
  })
} 
else {
  window.vm = new Vue({
    store,
    router,
    i18n,
    components: { App },
    render: (h) => h(App),
    mounted() {
      document.dispatchEvent(new Event("render-event"));
    },
  }).$mount("#biking-application");
}




// WEBPACK FOOTER //
// ./src/main.js